import EmployeeListConsent from './employee'

export {
    EmployeeListConsent,
}



// WEBPACK FOOTER //
// ./src/components/consent-management/employee-table/index.js